import { Outlet, useNavigate, useResolvedPath } from "react-router";
import Styles from "./Bilet.module.css";
import { Button } from "@mui/material";
import { useEffect, useState } from "react";

export function BiletPage() {
  const defState = {
    bilet: false,
    theme: false,
    question: false,
  };
  const [isActive, setActive] = useState({ ...defState });
  let path = useResolvedPath();
  useEffect(() => {
    const resolvedPath = path.pathname.split("/");
    setActive({ ...defState, [resolvedPath.slice(-1)]: true });
  }, [path.pathname]);
  const navHook = useNavigate();

  const handleNav = (e) => {
    const destanation = e.target.id;
    navHook(destanation);
  };
  return (
    <main>
      <div className={Styles.bilet_nav}>
        <Button
          disabled={isActive.bilet}
          onClick={handleNav}
          variant={isActive.bilet ? "contained" : "outlined"}
          id="/bilet">
          Билеты
        </Button>
        <Button
          disabled={isActive.question}
          onClick={handleNav}
          variant={isActive.question ? "contained" : "outlined"}
          id="question">
          Вопросы
        </Button>
        <Button
          disabled={isActive.theme}
          onClick={handleNav}
          variant={isActive.theme ? "contained" : "outlined"}
          id="theme">
          Темы вопросов
        </Button>
      </div>
      <Outlet />
    </main>
  );
}
